module.exports = __webpack_public_path__ + "img/upper_arm.efce4a2c.png";